import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SITE_CONFIG, NAVIGATION_ITEMS } from '@/config';
import { useThemeName } from '@/theme';

const Footer = () => {
  const navigate = useNavigate();
  const { themeName } = useThemeName();

  const footerBg = themeName === 'turquoise' ? '#f4f3f0' : '#f5f2ec';
  const textMain = themeName === 'turquoise' ? '#3a4f56' : '#4a403a';
  const textSub = themeName === 'turquoise' ? '#7a9090' : '#9a8d80';
  const borderColor = themeName === 'turquoise'
    ? 'rgba(42, 157, 143, 0.12)'
    : 'rgba(184, 149, 107, 0.15)';

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: footerBg,
        py: { xs: 8, md: 10 },
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' },
            gap: { xs: 5, md: 6 },
            mb: { xs: 6, md: 8 },
          }}
        >
          {/* ブランド */}
          <Box>
            <Typography
              sx={{
                fontFamily: '"Noto Serif JP", serif',
                fontSize: '1.0625rem',
                letterSpacing: '0.1em',
                color: textMain,
                fontWeight: 400,
                mb: 1,
              }}
            >
              {SITE_CONFIG.company.name}
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Cormorant Garamond", serif',
                fontStyle: 'italic',
                fontSize: '0.6875rem',
                letterSpacing: '0.15em',
                color: textSub,
                mb: 2.5,
              }}
            >
              {SITE_CONFIG.company.nameEn}
            </Typography>
            <Typography
              sx={{
                fontSize: '0.75rem',
                lineHeight: 2,
                color: textSub,
              }}
            >
              {SITE_CONFIG.company.description}
            </Typography>
          </Box>

          {/* ナビゲーション */}
          <Box>
            <Typography
              sx={{
                fontFamily: '"Cormorant Garamond", serif',
                fontStyle: 'italic',
                fontSize: '0.6875rem',
                letterSpacing: '0.15em',
                color: textSub,
                mb: 2.5,
              }}
            >
              Navigation
            </Typography>
            {NAVIGATION_ITEMS.map((item) => (
              <MuiLink
                key={item.path}
                component="button"
                onClick={() => navigate(item.path)}
                underline="none"
                sx={{
                  display: 'block',
                  color: textMain,
                  fontSize: '0.8125rem',
                  py: 0.5,
                  opacity: 0.65,
                  transition: 'all 0.3s ease',
                  '&:hover': { opacity: 1, color: 'primary.main' },
                }}
              >
                {item.label}
              </MuiLink>
            ))}
          </Box>

          {/* コンタクト */}
          <Box>
            <Typography
              sx={{
                fontFamily: '"Cormorant Garamond", serif',
                fontStyle: 'italic',
                fontSize: '0.6875rem',
                letterSpacing: '0.15em',
                color: textSub,
                mb: 2.5,
              }}
            >
              Contact
            </Typography>
            <Typography
              sx={{
                fontSize: '0.8125rem',
                color: textMain,
                opacity: 0.65,
                lineHeight: 1.8,
              }}
            >
              代表: {SITE_CONFIG.company.representative}
            </Typography>
            <MuiLink
              component="button"
              onClick={() => navigate('/contact')}
              underline="none"
              sx={{
                color: 'primary.main',
                fontSize: '0.8125rem',
                mt: 1.5,
                display: 'block',
                opacity: 0.85,
                transition: 'opacity 0.3s ease',
                '&:hover': { opacity: 1 },
              }}
            >
              お問い合わせはこちら
            </MuiLink>
          </Box>
        </Box>

        {/* コピーライト */}
        <Box
          sx={{
            borderTop: `1px solid ${borderColor}`,
            pt: 4,
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Cormorant Garamond", serif',
              fontSize: '0.6875rem',
              letterSpacing: '0.1em',
              color: textSub,
              opacity: 0.6,
            }}
          >
            &copy; {SITE_CONFIG.copyright.year} {SITE_CONFIG.copyright.holder}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
